import { useMutation, useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const StandardsGradebookQuery = graphql.persisted(
  "StandardsGradebookQuery",
  graphql(`
    query StandardsGradebookQuery($classOfferingId: ID!, $date: ISO8601Date!) {
      classOffering(id: $classOfferingId) {
        id
        gradebooks {
          id
          name
          transcriptName
          gradingMode
          assessmentScale { code label }
          assessmentDates
          categories { id }
          memberships {
            id
            rosterEntry {
              id
              state
              person { id firstName lastName }
            }
          }
          benchmarks {
            id
            name
            domain
            description
            position
            active
            assessmentsOn(date: $date) {
              id
              assessedOn
              levelCode
              levelLabel
              comment
              person { id firstName lastName }
            }
          }
        }
      }
    }
  `)
);

const UpdateStandardsGradebookMutation = graphql.persisted(
  "UpdateStandardsGradebook",
  graphql(`
    mutation UpdateStandardsGradebook($input: UpdateStandardsGradebookInput!) {
      updateStandardsGradebook(input: $input) {
        gradebook {
          id
          gradingMode
          assessmentScale { code label }
        }
        userErrors { message path }
      }
    }
  `)
);

const CreateBenchmarkMutation = graphql.persisted(
  "CreateBenchmark",
  graphql(`
    mutation CreateBenchmark($input: CreateBenchmarkInput!) {
      createBenchmark(input: $input) {
        benchmark { id name domain description position active }
        userErrors { message path }
      }
    }
  `)
);

const UpdateBenchmarkMutation = graphql.persisted(
  "UpdateBenchmark",
  graphql(`
    mutation UpdateBenchmark($input: UpdateBenchmarkInput!) {
      updateBenchmark(input: $input) {
        benchmark { id name domain description position active }
        userErrors { message path }
      }
    }
  `)
);

const DeleteBenchmarkMutation = graphql.persisted(
  "DeleteBenchmark",
  graphql(`
    mutation DeleteBenchmark($input: DeleteBenchmarkInput!) {
      deleteBenchmark(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const SaveBenchmarkAssessmentsMutation = graphql.persisted(
  "SaveBenchmarkAssessments",
  graphql(`
    mutation SaveBenchmarkAssessments($input: SaveBenchmarkAssessmentsInput!) {
      saveBenchmarkAssessments(input: $input) {
        assessments {
          id
          assessedOn
          levelCode
          levelLabel
          comment
          benchmarkId
          person { id firstName lastName }
        }
        userErrors { message path }
      }
    }
  `)
);

export {
  StandardsGradebookQuery,
  UpdateStandardsGradebookMutation,
  CreateBenchmarkMutation,
  UpdateBenchmarkMutation,
  DeleteBenchmarkMutation,
  SaveBenchmarkAssessmentsMutation,
};

export function useStandardsGradebookQuery(classOfferingId?: string, date?: string) {
  return useQuery(StandardsGradebookQuery, {
    variables: { classOfferingId: classOfferingId!, date: date! },
    skip: !classOfferingId || !date,
  });
}

export const useUpdateStandardsGradebook = () => useMutation(UpdateStandardsGradebookMutation);
export const useCreateBenchmark = () => useMutation(CreateBenchmarkMutation);
export const useUpdateBenchmark = () => useMutation(UpdateBenchmarkMutation);
export const useDeleteBenchmark = () => useMutation(DeleteBenchmarkMutation);
export const useSaveBenchmarkAssessments = () => useMutation(SaveBenchmarkAssessmentsMutation);
